


import { IChangeTracking } from "../../../changeTracking/iChangeTracking";
import { RequestDetail } from "./requestDetail";
import { RequestMaterial } from "./requestMaterial";
import { RequestLetter } from '../../requestDetail/models/requestLetter';


export class RequestDetailEdit implements IChangeTracking {
    private _requestDetail: RequestDetail;
    private _requestMaterial : RequestMaterial;
    //private _trackingId: number;
    private _current: any;
    private _localizedCurrentTime: string;
    
    constructor(private _model: any) {
        this._current = this._model ? angular.copy(this._model) : {};
        this._requestDetail = this._current.requestDetail ? new RequestDetail(this._current.requestDetail) : undefined;
        this._requestMaterial = this._current.requestMaterial ? new RequestMaterial(this._current.requestMaterial) : undefined;
        this._localizedCurrentTime = (new Date()).toLocaleString();
    }
    get requestDetail(): RequestDetail {
        return this._requestDetail;
    }

    set requestDetail(val: RequestDetail) {
        this._requestDetail = val;
    }

    get localizedCurrentTime(): string {
        return this._localizedCurrentTime;
	}

	set localizedCurrentTime(val: string) {
		this._localizedCurrentTime = val;
	}

    get requestMaterial(): RequestMaterial {
        return this._requestMaterial;
    }

    set requestMaterial(val: RequestMaterial) {
        this._requestMaterial = val;
    }

    get trackingId(): number {
        return this._current.trackingId;
    }

    set trackingId(val : number ) {
        this._current.trackingId = val;
    }

    get rowVersion(): any {
        return this._current.rowVersion;
    }
    set rowVersion(value: any) {
        this._current.rowVersion = value;
    }

    get errorMessage(): string {
        return this._current.errorMessage;
    }
    set errorMessage(value: string) {
        this._current.errorMessage = value;
    }

    get requestLetter(): RequestLetter {
        return this._current.requestLetter;
    }

    set requestLetter(val: RequestLetter) {
        this._current.requestLetter = val;
    }


    hasChanges(): boolean {
        return !angular.equals(this._current, this._model);
    }

    revert(): void {
        this._current = angular.copy(this._model);
    }

    commit(): void {
        this._model = angular.copy(this._current);
    }

    toJson(): any {
        return this._current;
    }
}


/** WEBPACK FOOTER **
 ** ./DeliveryCreate/UI/app/features/request/requestDetailEdit/models/requestDetailEdit.ts
 **/